import RecordAction from '../RecordAction';
import { type Page } from 'components/framework/models';
import { type SortChildPageTypeEnum_value } from 'components/framework/models/generated/types';
import { type MenuContent } from 'components/SelectionController/ActionMenuItem';

export class SortChildPagesAction extends RecordAction<Page> {
  recordTypes = ['Page'];
  emptySubmenuContent = 'No options available';

  get title() {
    return 'Sort child documents by';
  }

  get icon() {
    return 'fa-regular fa-bars-sort';
  }

  get hasSubmenu() {
    return true;
  }

  prepareSubmenuItems(): MenuContent {
    return [
      { label: 'Name', data: { sort: 'name' } },
      { label: 'Date created', data: { sort: 'createdAt' } },
    ];
  }

  showForRecord(record: Page): record is Page {
    return super.showForRecord(record) && record.childrenCount > 1;
  }

  async runForRecords(
    records: Page[],
    { sort }: { sort: SortChildPageTypeEnum_value }
  ) {
    if (!sort) return;
    await Promise.all(records.map(record => record.sortChildren({ sort })));
  }
}
